(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["extra-header-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.copy-code').forEach(btn => {
    btn.addEventListener('click', () => {
      const codeEl = btn.querySelector('.code');
      navigator.clipboard.writeText(codeEl.textContent.trim());
      btn.querySelector('.icon-copy').classList.add('hidden');
      btn.querySelector('.icon-check').classList.remove('hidden');
      setTimeout(() => {
        btn.querySelector('.icon-copy').classList.remove('hidden');
        btn.querySelector('.icon-check').classList.add('hidden');
      }, 2000);
    });
  });

  document.addEventListener("scroll", function() {
    const headerBar = document.querySelector('.header-alert-bar');
    const scrollPosition = window.scrollY;

    if (scrollPosition > 80) {
      headerBar.classList.add('fixed');
    } else {
      headerBar.classList.remove('fixed');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-collection-action-steps"] && !Shopify.designMode) return;
  try {
    
  const promoStepsHeader = document.querySelector('.promo-steps__header');
  if(promoStepsHeader) {
      promoStepsHeader.addEventListener('click', function() {
        this.closest('.promo-steps').classList.remove('promo-steps--start');
        this.closest('.promo-steps').classList.toggle('promo-steps--open');        
      });    
  }
  

  } catch(e) { console.error(e); }
})();
})();
